import { render, staticRenderFns } from "./TokenLog.vue?vue&type=template&id=b4a155b2&scoped=true"
import script from "./TokenLog.vue?vue&type=script&lang=js"
export * from "./TokenLog.vue?vue&type=script&lang=js"
import style0 from "./TokenLog.vue?vue&type=style&index=0&id=b4a155b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a155b2",
  null
  
)

export default component.exports